export type ChannelVariableKind = "channel" | "channelGroup";

/** `{{channel:id}}` is the default formula. `{{channel:id:formatTypeId}}` targets one format. */
export const channelVariablePlaceholder = (kind: ChannelVariableKind, id: number, formatTypeId: number | null) =>
    formatTypeId == null ? `{{${kind}:${id}}}` : `{{${kind}:${id}:${formatTypeId}}}`;

const CHANNEL_VARIABLE_PATTERN = /^(?:\{\{)?(channel|channelGroup):(\d+)(?::(\d+))?(?:\}\})?$/;

export const parseChannelVariable = (
    value: string,
): { kind: ChannelVariableKind; id: number; formatTypeId: number | null } | null => {
    const match = value.match(CHANNEL_VARIABLE_PATTERN);
    if (!match) return null;
    return {
        kind: match[1] as ChannelVariableKind,
        id: Number(match[2]),
        formatTypeId: match[3] == null ? null : Number(match[3]),
    };
};

export const channelVariableLabel = (name: string, formatName?: string) =>
    formatName ? `${name} — ${formatName}` : name;
